export default __webpack_public_path__ + "static/media/background-home.c9dc859c.jpg";